import CancelablePromise from 'cancelable-promise';
import { ApiResult } from '../types/ApiResult';
import { Store } from '../types/Store';
import apiClient from './appApi';

export default function getStores(params: { location: string }): CancelablePromise<ApiResult<Store[]>> {
  return apiClient.post<ApiResult<Store[]>, {}>('/CMSPages/SonovaBookAppointment/GetStores.ashx', params);
}
